import React, { useState, useEffect } from 'react';
import { Box, Grid } from "@mui/material";
import { FaFileImage, FaFilePdf, FaFileLines } from "react-icons/fa6";
import { IFrontTask, IEvidence } from "../../../../interfaces/ITask";
import { Button, Input } from 'reactstrap';
import MediaViewer from './MediaViewer';
import './Components.css';
//import './TaskEvidences.css';
interface TaskEvidencesProps {
  task: IFrontTask;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUpload: () => void;
  onEvidenceClick: (link: string, id: string) => void;
}

const TaskEvidences: React.FC<TaskEvidencesProps> = ({
  task,
  onFileChange,
  onUpload,
  onEvidenceClick
}) => {
  const [selectedMediaIndex, setSelectedMediaIndex] = useState<number | null>(null);

  const handleMediaClick = (evidence: IEvidence, index: number) => {
    setSelectedMediaIndex(index);
  };

  const extractDateFromS3Key = (s3Key: string): string => {
    // Tenta extrair data do nome do arquivo ou retorna uma data padrão
    try {
      // Se contém um timestamp ObjectId no começo do caminho, usa ele
      if (s3Key.includes('Tracker/')) {
        const parts = s3Key.split('/');
        if (parts.length >= 2) {
          const taskId = parts[1];
          // Se o taskId parece ser um ObjectId (24 caracteres hex), extrai timestamp
          if (taskId.length === 24 && /^[0-9a-fA-F]+$/.test(taskId)) {
            const timestamp = parseInt(taskId.substring(0, 8), 16);
            return new Date(timestamp * 1000).toLocaleDateString('pt-BR');
          }
        }
      }
      return 'Data não disponível';
    } catch {
      return 'Data não disponível';
    }
  };

  const handleCloseMediaViewer = () => {
    setSelectedMediaIndex(null);
  };

  const handleNavigateMedia = (direction: 'prev' | 'next') => {
    if (selectedMediaIndex !== null && task.evidencies) {
      const newIndex = direction === 'prev' 
        ? (selectedMediaIndex - 1 + task.evidencies.length) % task.evidencies.length
        : (selectedMediaIndex + 1) % task.evidencies.length;
      setSelectedMediaIndex(newIndex);
    }
  };

  return (
    <div className="evidence-section">
      <div className="evidence-header">
        <h3 className="evidence-title">
          📎 Evidências
        </h3>
      </div>
      
      <div className="evidence-upload-wrapper">
        <Input
          className="evidence-upload-input"
          type="file"
          name="file"
          id="evidencies-files"
          multiple
          onChange={onFileChange}
          placeholder="Selecione arquivos..."
        />
        <Button
          onClick={onUpload}
          className="evidence-upload-button"
          id="evidencies-button"
        >
          📤 Adicionar
        </Button>
      </div>
      <Grid container rowSpacing={1} spacing={1}>
        {task.evidencies != undefined && task.evidencies != null && (
          <>
            {task.evidencies.map((item: IEvidence, index) => {
              const isImage = item.fileName.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);
              return (
                <Grid key={index}>
                  <div
                    className="evidence-card"
                    onClick={() => handleMediaClick(item, index)}
                  >
                    {isImage ? (
                      <FaFileImage size={36} color="#FAE06E" />
                    ) : item.fileName.toLowerCase().includes("pdf") ? (
                      <FaFilePdf size={36} color="#F87171" />
                    ) : (
                      <FaFileLines size={36} color="#60A5FA" />
                    )}
                    <span className="evidence-filename">{item.fileName?.slice(0, 30) || 'Arquivo'}</span>
                    <span className="evidence-date">{extractDateFromS3Key(item.id)}</span>
                  </div>
                </Grid>
              );
            })}
          </>
        )}
      </Grid>

      <MediaViewer
        isOpen={selectedMediaIndex !== null}
        onClose={handleCloseMediaViewer}
        media={selectedMediaIndex !== null && task.evidencies ? task.evidencies[selectedMediaIndex] : null}
        allMedia={task.evidencies || []}
        currentIndex={selectedMediaIndex || 0}
        onNavigate={handleNavigateMedia}
      />
    </div>
  );
};

export default TaskEvidences; 